/**
 * Round to the nearest even integer. libx264 with yuv420p requires even width/height.
 * Matches studio useCanvasResizer so canvas layout and export stay consistent.
 */
export function roundToNearestEven(number: number): number {
  const floor = Math.floor(number);
  const fractionalPart = number - floor;
  const rounded = fractionalPart < 0.5 ? floor : floor + 1;
  return rounded % 2 === 0
    ? rounded
    : fractionalPart < 0.5
      ? rounded + 1
      : rounded - 1;
}

export function ensureEvenVideoDimensions(
  width: number,
  height: number,
): { width: number; height: number } {
  return {
    width: roundToNearestEven(width),
    height: roundToNearestEven(height),
  };
}
